export default __webpack_public_path__ + "bee778bc5a26fb329d08bf84576807d3.svg";